import React from 'react';
import { Tag } from 'antd';

const Status = ({ d }) => {
  if (d.is_active) {
    return (
      <Tag color="green" style={{ fontSize: '14px', fontWeight: 400 }}>
        Đang hoạt động
      </Tag>
    );
  } else {
    return (
      <Tag color="volcano" style={{ fontSize: '14px', fontWeight: 400 }}>
        Ngừng hoạt động
      </Tag>
    );
  }
};

export default Status;
